module.exports = __webpack_public_path__ + "static/lots-of-dots-aff7e552c72fda5afdb9cc73f9a52206.png";